module.exports = __webpack_public_path__ + "static/media/RedRay.28c8caed.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Rays/RedRay.png
// module id = 38
// module chunks = 0